<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="d-block custom-dropdown" tabindex="0">
    <label class="dropdown-label" [class.floating]="selectedLabel || isOpen">
        {{ placeholder }}
    </label>

    <div class="dropdown-selected d-flex justify-content-between align-items-center" [class.isOpen]="isOpen"
        (click)="toggleDropdown($event)">
        <span class="selected-value">
            {{ selectedLabel || '' }}
        </span>
        <span class="arrow" [class.open]="isOpen">&#9662;</span>
    </div>

    <div class="dropdown-menu-custom" *ngIf="isOpen">
        <div class="dropdown-item-custom" *ngFor="let item of items" (click)="selectItem(item)">
            {{ item.label }}
        </div>
    </div>
</div>